export const isMobileApp = () =>
  (window.navigator.userAgent || '').toLowerCase().indexOf('hermes') !== -1;
